<template>
  <div class="c-password">
    <Input
      :type="isVisible ? 'text' : 'password'"
      :name="name"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :value="value"
      :disabled="disabled"
      class="c-input c-password__input"
      trim
      @enter="enter"
      @input="input"
    />
    <span></span>
    <ButtonEye
      class="c-password__toggle"
      :disabled="disabled"
      @click="toggle"
    />
  </div>
</template>

<script>
import ButtonEye from '@/components/ButtonEye';
import Input from '@/components/Input';

export default {
  components: {
    ButtonEye,
    Input
  },

  props: {
    disabled: {
      type: Boolean,
      required: false
    },
    maxlength: {
      type: [Number, String],
      required: false
    },
    name: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: '入力してください'
    },
    value: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isVisible: false
    };
  },

  methods: {
    enter() {
      this.$emit('enter');
    },
    input(value) {
      this.$emit('input', value);
    },
    toggle(isVisible) {
      this.isVisible = isVisible;
    }
  }
};
</script>
